import * as React from "react";
import { Count, Menu as RAMenu, usePermissions } from "react-admin";
import PaymentsIcon from "@mui/icons-material/CreditCard";
import RestaurantsIcon from "@mui/icons-material/Storefront";
import SettingsIcon from "@mui/icons-material/Settings";
import ReviewsIcon from "@mui/icons-material/StarRate";
import ReportIcon from "@mui/icons-material/Report";
import RuleIcon from "@mui/icons-material/Rule";
import { ROLE_TYPES } from "../enums/Roles";
import SubMenu from "./SubMenu";
import { ListItemText } from "@mui/material";
import { REPORT_STATUS } from "../enums/ReportStatus";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";

const RestaurantMenuItems = () => {
  const restaurant = localStorage.getItem("restaurant");

  return (
    <>
      <RAMenu.ResourceItem name="purchases" />
      <RAMenu.ResourceItem name="redeemed-rewards" />
      <RAMenu.ResourceItem name="purchases/activity" />

      <SubMenu primaryText="Mi Local" leftIcon={<RestaurantsIcon />}>
        <RAMenu.ResourceItem name="restaurants" />
        <RAMenu.ResourceItem name="restaurants/stats" />
      </SubMenu>

      <RAMenu.ResourceItem name="products" />
      <RAMenu.ResourceItem name="coupons" />
      <RAMenu.ResourceItem name="reviews" />

      {restaurant && JSON.parse(restaurant).subscriptionPlan && (
        <RAMenu.Item
          key="payments"
          to="/payments"
          primaryText="Suscripción"
          leftIcon={<PaymentsIcon />}
        />
      )}
    </>
  );
};

const AdminMenuItems = () => {
  const reportsCount = () => (
    <Count resource="reports" filter={{ status: [REPORT_STATUS.PENDING] }} />
  );

  const restaurantsDraftCount = () => (
    <Count resource="restaurants" filter={{ type: RESTAURANT_TYPES.DRAFT }} />
  );

  return (
    <>
      <SubMenu
        primaryText="Locales"
        leftIcon={<RestaurantsIcon />}
        count={restaurantsDraftCount()}
      >
        <RAMenu.ResourceItem name="restaurants" />
        <RAMenu.ResourceItem name="restaurants/stats" />
        <RAMenu.ResourceItem name="restaurant-mp-tokens" />
        <RAMenu.Item
          name="restaurants-draft"
          key="restaurants-draft"
          to="/restaurants-draft"
          primaryText="Solicitudes"
          leftIcon={<RuleIcon />}
        >
          <div className="flex items-center mr-6">
            <ListItemText disableTypography primary="Solicitudes" />
            {restaurantsDraftCount()}
          </div>
        </RAMenu.Item>
      </SubMenu>

      <RAMenu.ResourceItem name="products" />
      <RAMenu.ResourceItem name="users" />
      <RAMenu.ResourceItem name="coupons" />
      <RAMenu.ResourceItem name="purchases" />
      <RAMenu.ResourceItem name="redeemed-rewards" />
      <RAMenu.ResourceItem name="banners" />
      <RAMenu.ResourceItem name="sections" />
      <RAMenu.ResourceItem name="videos" />
      <RAMenu.ResourceItem name="community-posts" />

      <RAMenu.ResourceItem name="discount-coupons" />

      <SubMenu
        primaryText="Calificaciones"
        leftIcon={<ReviewsIcon />}
        count={reportsCount()}
      >
        <RAMenu.ResourceItem name="reviews" />
        <RAMenu.Item
          name="reports"
          key="reports"
          to="/reports"
          primaryText="Reportes"
          leftIcon={<ReportIcon />}
        >
          <div className="flex items-center mr-6">
            <ListItemText disableTypography primary="Reportes" />
            {reportsCount()}
          </div>
        </RAMenu.Item>
      </SubMenu>

      <RAMenu.ResourceItem name="billing" />

      <RAMenu.ResourceItem name="product-events" />

      <SubMenu primaryText="Planes" leftIcon={<PaymentsIcon />}>
        <RAMenu.ResourceItem name="subscription-plans" />
        <RAMenu.ResourceItem name="restaurant-subscription-plans" />
      </SubMenu>

      <SubMenu primaryText="Datos Maestros" leftIcon={<SettingsIcon />}>
        <RAMenu.ResourceItem name="regions" />
        <RAMenu.ResourceItem name="categories" />
        <RAMenu.ResourceItem name="place-types" />
        <RAMenu.ResourceItem name="place-targets" />
        <RAMenu.ResourceItem name="districts" />
      </SubMenu>
    </>
  );
};

const Menu = () => {
  const { permissions } = usePermissions();

  if (permissions === ROLE_TYPES.RESTAURANT_DRAFT) {
    return <></>;
  }
  return (
    <RAMenu>
      {permissions === ROLE_TYPES.RESTAURANT && <RestaurantMenuItems />}
      {permissions === ROLE_TYPES.ADMIN && <AdminMenuItems />}
    </RAMenu>
  );
};

export default Menu;
